<template>
  <div class="IndexKeynoteSpeech contentBox">
    <router-link class="index-title" :to="{ path: '/keynoteSpeech', query:{ name: '主题演讲' } }" target="_blank">主题演讲</router-link>
    <div class="content" v-if="ispc">
      <div class="KeynoteSpeechBox" v-for="(item, index) in speechList" :key="index">
        <h3><router-link :to="{ path: '/keynoteSpeech', query:{ name: '主题演讲',videoSubclassId: item.videoSubclassId } }">{{ item. title }}</router-link></h3>
        <swiper class="live-swiper-pc" :options="options">
          <swiper-slide v-for="(it, ind) in item.videos" :key="ind">
            <a :href="it.url" target="_blank">
              <div class="speach-img">
                <img :src="it.imagePath" />
                <span></span>
              </div>
              <p class="Linebreak">{{ it.name }}</p>
            </a>
          </swiper-slide>
          <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
          <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
        </swiper>
      </div>
    </div>
    <div class="content" v-else>
      <div class="speech-cover">
        <div class="KeynoteSpeechBox" v-for="(item, index) in speechList" :key="index">
          <h3><router-link :to="{ path: '/keynoteSpeech', query:{ name: '主题演讲',videoSubclassId: item.videoSubclassId } }">{{ item. title }}</router-link></h3>
          <p class="slide-more">向左滑动查看更多</p>
          <ul>
            <li v-for="(it, ind) in item.videos" :key="ind">
              <a :href="it.url">
                <div class="speach-img">
                  <img :src="it.imagePath" />
                  <span></span>
                </div>
                <p class="Linebreak">{{ it.name }}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { KeynoteSpeechAllApi } from '../request/api.js'
  export default{
    name: 'KeynoteSpeech',
    data(){
      return {
        speechList: [],
        options: {
          observer:true,
          observeSlideChildren:true,
          slidesPerView: 4,
          spaceBetween: 18,
          navigation: {
            nextEl: '.KeynoteSpeechBox .swiper-button-next',
            prevEl: '.KeynoteSpeechBox .swiper-button-prev'
          }
        }
      }
    },
    props:{
      ispc: {
        type: Boolean,
        default: true
      }
    },
    mounted() {
      this.GetSpeechApiFn();
    },
    methods:{
      GetSpeechApiFn() {
        KeynoteSpeechAllApi({
          ChildrenSorting: 'displayIndex asc,creationDate asc'
        }).then(res => {
          this.speechList = res;
        });
      }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .KeynoteSpeechBox{
      height: 290px;
      position: relative;
      padding: 0 50px;
      margin-bottom: 30px;
    }

    .KeynoteSpeechBox:last-child{
      margin-bottom: 0;
    }

    .live-swiper-pc{
      height: 290px;
      position: initial;
    }

    /* 论坛标题 */
    .KeynoteSpeechBox h3{
      text-align: center;
    }

    .KeynoteSpeechBox h3 a{
      border-bottom: 1px solid #FFFFFF;
      font-size: 20px;
      color: #FFFFFF;
    }

    /* 演讲li */
    .KeynoteSpeechBox .live-swiper-pc a{
      display: block;
      width: 100%;
      color: #FFFFFF;
    }

    .KeynoteSpeechBox .speach-img{
      position: relative;
    }

    .KeynoteSpeechBox .speach-img span{
      display: block;
      width: 44px;
      height: 45px;
      background: url(../assets/image/index-speech-video.png) no-repeat;
      background-size: 100% 100%;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .KeynoteSpeechBox a img{
      width: 100%;
      height: 194px;
    }

    .KeynoteSpeechBox a p{
      font-size: 16px;
      line-height: 24px;
      max-height: 48px;
    }

    /* 自定义swiper切换按钮 */
    .swiper-btn{
      width: 30px;
      height: 51px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
    }

    .index-swiper-next{
      background: url(../assets/image/index-swiper-right.png) no-repeat center center;
      background-size: 10px 21px;
      right: 0;
    }

    .index-swiper-prev{
      background: url(../assets/image/index-swiper-left.png) no-repeat center center;
      background-size: 10px 21px;
      left: 0;
    }

  }
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    /* 内容 */
    .speech-cover{
      background: rgba(0,0,0,.3);
      padding: .3rem 0 .3rem .3rem;
    }

    .KeynoteSpeechBox{
      margin-top: .4rem;
      color: #FFFFFF;
      font-size: .28rem;
    }

    .KeynoteSpeechBox:first-child{
      margin-top: 0;
    }

    /* 论坛标题 */
    .KeynoteSpeechBox>h3{
      text-align: center;
    }

    .KeynoteSpeechBox>h3 a{
      border-bottom: 1px solid #FFFFFF;
      color: #FFFFFF;
    }

    /* 滑动查看更多 */
    .KeynoteSpeechBox .slide-more{
      font-size: .2rem;
      letter-spacing: 2px;
      text-align: center;
      color: rgba(255, 255, 255, .8);
      margin: 5px 0 .18rem;
    }

    /* 演讲li */
    .KeynoteSpeechBox ul{
      overflow: hidden;
      overflow-x: auto;
      display: flex;
    }

    .KeynoteSpeechBox li{
      margin-right: .2rem;
    }

    .KeynoteSpeechBox li a{
      display: block;
      width: 2.25rem;
      color: #FFFFFF;
    }

    .KeynoteSpeechBox .speach-img{
      position: relative;
    }

    .KeynoteSpeechBox .speach-img span{
      display: block;
      width: .56rem;
      height: .56rem;
      background: url(../assets/image/play_icon.png) no-repeat;
      background-size: 100% 100%;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .KeynoteSpeechBox a img{
      width: 2.25rem;
      height: 1.6rem;
    }

    .KeynoteSpeechBox a p{
      line-height: .4rem;
      max-height: .88rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexKeynoteSpeech.vue